module.exports = __webpack_public_path__ + "static/media/commissions6.2d9bfa0e.png";